import {Stack, Typography} from '@mui/material'
import React, {useCallback, useEffect, useState} from 'react'
import ReferralsService from '@/services/api/Referrals'
import {errorCodeHandler} from '@/helpers/localErrorCodeHandler'
import SimpleLoader from '@/components/UI/simpleLoader'
import TransCustom from '@/components/UI/i18next'
import {colors} from '@/constants'
import {ReactComponent as CopyIcon} from '@/assets/svgs/CopyIcon.svg'
import useCopyToClipboard from '@/hooks/useCopyToClipboard'
import {isErrorResponse} from '@/helpers/IsErrorResponse'

const Index = () => {
  const [isLoad, setIsLoad] = useState(false)
  const [data, setData] = useState<{
    refferals: string[]
    unused_codes: string[]
  } | null>(null)
  const {copyToClipboard} = useCopyToClipboard()
  const getLOIReferral = useCallback(async () => {
    try {
      const response = await ReferralsService.getReferralLoi()
      if (response.status === 200) {
        if (isErrorResponse(response.data)) {
        } else {
          setData(response.data)
        }
      }

      setTimeout(() => {
        setIsLoad(true)
      }, 1000)
    } catch (e) {
      errorCodeHandler(e)
    }
  }, [])

  useEffect(() => {
    void getLOIReferral()
  }, [])

  return (
    <>
      {isLoad ? (
        data ? (
          <Stack gap="20px" height="100%" minHeight={0} minWidth={0}>
            <Stack direction="row" gap="40px" flex="none" minWidth={0}>
              <Stack gap="10px" width="180px" flex="none">
                <TransCustom
                  variant="button"
                  i18nKey="1585"
                  color={colors.yellow}
                />
                <TransCustom
                  i18nKey="1586"
                  fontSize="12px"
                  color={colors.gray}
                />
              </Stack>
              <Stack gap="20px" flex="auto" minWidth={0}>
                {data.unused_codes.map((referralCode: string) => (
                  <Stack
                    justifyContent="space-between"
                    alignItems="center"
                    direction="row"
                    gap="10px"
                    marginTop="2px"
                    minWidth={0}
                    key={referralCode}>
                    <Typography
                      variant="body1"
                      sx={{wordBreak: 'break-all', minWidth: 0}}>
                      {referralCode}
                    </Typography>
                    <CopyIcon
                      width="24px"
                      height="24px"
                      style={{flex: 'none'}}
                      className="svg-first-color-fill pointer"
                      onClick={() => copyToClipboard(referralCode)}
                    />
                  </Stack>
                ))}
              </Stack>
            </Stack>
            <Stack width="100%" gap="12px" flex="auto" minHeight={0}>
              <TransCustom
                i18nKey="1394"
                params={{param1: data.refferals.length}}
                variant="body2"
                color={colors.yellow}
              />
              <Stack
                width="100%"
                flex="auto"
                minHeight={0}
                overflow="hidden"
                borderTop={`1px solid ${colors.gray}`}
                borderBottom={`1px solid ${colors.gray}`}>
                <Stack
                  padding="10px 0"
                  width="100%"
                  flex="auto"
                  minHeight={0}
                  overflow="auto"
                  className="events-block"
                  gap="24px">
                  {data.refferals.length > 0 ? (
                    data.refferals.map((item) => (
                      <Stack direction="row" key={item}>
                        <Typography
                          color={colors.white}
                          fontSize="20px"
                          fontWeight="500">
                          {item}
                        </Typography>
                      </Stack>
                    ))
                  ) : (
                    <Stack></Stack>
                  )}
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        ) : (
          <Stack
            bgcolor="#FFFDF01F"
            padding="10px 20px"
            borderRadius="5px"
            width="100%"
            textAlign="center">
            <TransCustom i18nKey="1584" color={colors.orange} variant="body1" />
          </Stack>
        )
      ) : (
        <SimpleLoader isLoad={true} />
      )}
    </>
  )
}

export default Index
